import { createAction, props } from '@ngrx/store';
import {
  AllocatedExpense,
  Expenses,
  NewExpense,
  SelectedUserExpenses,
  UpdateExpense,
} from '../state/expenses.state';

export const clearExpensesState = createAction(
  '[Expenses] CLEAR_EXPENSES_STATE',
);

export const createNewExpense = createAction(
  '[Expenses] CREATE_NEW_EXPENSE',
  props<{ newExpense: NewExpense }>(),
);

export const createNewExpenseSuccess = createAction(
  '[Expenses] CREATE_NEW_EXPENSE_SUCCESS',
);

export const createNewExpenseError = createAction(
  '[Expenses] CREATE_NEW_EXPENSE_ERROR',
);

export const updateAllocatedExpenses = createAction(
  '[Expenses] UPDATE_NEW_EXPENSE_VALUES',
  props<{ allocatedExpenses: AllocatedExpense[] }>(),
);

export const getExpenses = createAction('[Expenses] GET_EXPENSES');

export const getExpensesSuccess = createAction(
  '[Expenses] GET_EXPENSES_SUCCESS',
  props<{ expenses: any[] }>(),
);

export const getExpensesError = createAction('[Expenses] GET_EXPENSES_ERROR');

export const selectedExpense = createAction(
  '[Expenses] SELECTED_EXPENSE',
  props<{ selectedExpense: Expenses }>(),
);

export const getExpenseTransactions = createAction(
  '[Expenses] GET_EXPENSES_BY_USER_ID',
);

export const getExpenseTransactionsSuccess = createAction(
  '[Expenses] GET_EXPENSES_BY_USER_ID_SUCCESS',
  props<{ selectedUserExpenses: SelectedUserExpenses[] }>(),
);

export const getExpenseTransactionsError = createAction(
  '[Expenses] GET_EXPENSES_BY_USER_ID_ERROR',
);

export const clearSelectedExpense = createAction(
  '[Expenses] CLEAR_SELECTED_EXPENSE',
);

export const deleteExpenseTransaction = createAction(
  '[Expenses] DELETE_EXPENSE_TRANSACTION',
  props<{ expenseId: number }>(),
);

export const deleteExpenseTransactionSuccess = createAction(
  '[Expenses] DELETE_EXPENSE_TRANSACTION_SUCCESS',
  props<{ userId: number; expenseId: number }>(),
);

export const deleteExpenseTransactionError = createAction(
  '[Expenses] DELETE_EXPENSE_TRANSACTION_ERROR',
);

export const viewSelectedUserExpense = createAction(
  '[Expenses] VIEW_SELECTED_USER_EXPENSE',
  props<{ selectedUserExpense: SelectedUserExpenses }>(),
);

export const clearSelectedUserExpense = createAction(
  '[Expenses] CLEAR_SELECTED_USER_EXPENSE',
);

export const updateExpenseTransaction = createAction(
  '[Expenses] UPDATE_EXPENSE_TRANSACTION',
  props<{ payload: UpdateExpense }>(),
);

export const updateExpenseTransactionSuccess = createAction(
  '[Expenses] UPDATE_EXPENSE_TRANSACTION_SUCCESS',
);

export const updateExpenseTransactionError = createAction(
  '[Expenses] UPDATE_EXPENSE_TRANSACTION_ERROR',
);
